/**
 * RESPONSIBILITY: the Leadership page's opening band.
 *
 * Words only, over the brand colour — the people themselves are further down the page,
 * and a photograph up here would compete with the portraits that matter.
 */
import type { LeadershipHeroSection } from '@app/sections';

export function LeadershipHero({ c }: { c: LeadershipHeroSection }) {
  return (
    <section className="ldr-hero">
      <span className="ldr-hero__glow" aria-hidden="true" />
      <div className="wrap ldr-hero__content">
        {c.eyebrow && <p className="ldr-hero__eyebrow">{c.eyebrow}</p>}
        <h1 className="ldr-hero__h1">{c.heading}</h1>
        {c.intro && <p className="ldr-hero__sub">{c.intro}</p>}
      </div>
    </section>
  );
}
